<section class="d-flex flex-column" id="testimonial" [style.background-color]="'#F9F9F9'">
  <div class="container">
    <div class="row justify-content-center">
      <h2 class="text-center text-uppercase pt-5 pb-4 p-md-5" i18n>Testimonios Reales, Resultados Reales</h2>
    </div>
  </div>
  <div #testimonialsCarousel class="position-relative">
    <owl-carousel-o [options]="testimonial_carousel_options" (wheel)="carouselScroll($event)">
      <div>controles</div>
      <ng-template carouselSlide *ngFor="let element of this.testimonials, let i = index">
        <div class="card">
          <div class="card-body">
            <h3 class="">{{element.author}} <span *ngIf="element.age" i18n>- {{element.age}} años</span></h3>
            <p class=" text-uppercase">{{element.topic}}</p>
            <div class="card-text" innerHTML="{{element.testimonial}}"></div>
          </div>
        </div>
      </ng-template>
    </owl-carousel-o>
  </div>
  <div class="container my-5">
    <p class="text-muted fs-14px mb-0" i18n>
      <strong class="text-dark text-uppercase">DESCARGO DE RESPONSABILIDAD: </strong>
      DESCARGO DE RESPONSABILIDAD: Los testimonios anteriores pueden no ser representativos de la experiencia promedio
      de microdosis que no está diseñada y guiada por Bhavani. La microdosis autodirigida, o trabajar con facilitadores
      novatos que no tienen la profundidad de conocimiento científico de Bhavani y acceso a formulaciones personalizadas
      con dosis precisas, probadas en laboratorio y libres de contaminantes, probablemente no producirá resultados
      similares y puede ser perjudicial.
    </p>
  </div>
</section>